import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import Flexbox from "flexbox-react";
import { Drawer, Button, InputGroup, Icon, FormGroup, HTMLSelect } from "@blueprintjs/core";
import { FilledButton, OutlinedButton } from "../buttons-20250224T111359Z-001/buttons";
import axios from "axios";
import Cookies from "js-cookie";
import GoalReadOnlyList from "./GoalReadOnlyList";
import AssessmentReadOnlyList from "./AssessmentReadOnlyList";
const UserReadOnlyDrawer = observer(({ isOpen, onClose, goalData,assessmentData }) => {
 
  return (
    <Drawer 
    portalContainer={document.body}
    isOpen={isOpen} 
    onClose={onClose} 
    size={"70%"} 
    title={"User Goals and Assessment Data"}>
      <Flexbox flexDirection="column" flexGrow={1} padding="25px"  style={{ overflowY: "auto"}} >
        {goalData?.length > 0 && 
          <GoalReadOnlyList data={goalData} />
        }
        {assessmentData?.length >0 && 
          <AssessmentReadOnlyList data={assessmentData} isAnswerAllowedOnQuestion={isAnswerAllowedOnQuestion} />
        }
      </Flexbox>
    </Drawer>
  );
});

export default UserReadOnlyDrawer;
